import React from "react";
import useJobWorkshopConfigData from "../../../hooks/useJobWorkshopConfigData";
import {getDataFresh, getJobWorkshopConfigData} from "../../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import LoadingSpinner from "../../Utils/Spinner";
import {Box, Columns, Table} from "react-bulma-components";
import Collapsible from "react-collapsible";
import JobWorkshopConfigRow from "./JobWorkshopConfigRow";
import {createSetJobWorkshopConfigData} from "../../../actions/dataActions";
import axios from "axios";
import {NotificationManager} from "react-notifications";



export default function JobWorkshopConfig(){
    const dispatch = useDispatch();
    let loaded = useJobWorkshopConfigData({});
    let data = useSelector(getJobWorkshopConfigData);

    const onChange = (e, index) => {
        let newConf = {...data.results[index], [e.target.name]: e.target.value};
        data.results[index] = newConf;
        dispatch(createSetJobWorkshopConfigData(data.results));
    }

    const onSave = (item, index) => {
        const conf = {
            method: "put",
            data: item,
            url: "api/workshopconfig/"+item.id
        }
        axios(conf).then(res =>{
            data.results[index] = res.data
            dispatch(createSetJobWorkshopConfigData(data.results));
        }).catch(err =>{
            NotificationManager.error("There was an error");
        })
    }


    if(!loaded){
        return <LoadingSpinner/>
    }

    return (
        <div>
            <br/>
            <Box>
                <Collapsible
                    trigger={"Workshop Config"}
                    className={"title"}
                    triggerOpenedClassName={"title"}
                >
                    <Columns>
                        <Columns.Column>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Reminder (days after book in date)</th>
                                        <th>Warning Days (days after book in date)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map( (item, index) => (
                                    <JobWorkshopConfigRow
                                        data={item}
                                        index={index}
                                        onChange={onChange}
                                        onSave={onSave}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Columns.Column>
                    </Columns>
                </Collapsible>
            </Box>
        </div>
    )


}